import { render, staticRenderFns } from "./SearchEvents.vue?vue&type=template&id=2200059a&scoped=true"
var script = {}
import style0 from "./SearchEvents.vue?vue&type=style&index=0&id=2200059a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2200059a",
  null
  
)

export default component.exports